import * as React from 'react';
import { Icon } from '../icon/icon.component';
import { IconUtils } from '../icon/icons.utils';
/** Wraps its children with optional icons on either side */

export var IconWrapper = function IconWrapper(_ref) {
  var leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      children = _ref.children;
  return React.createElement(React.Fragment, null, leftIcon && (IconUtils.isIconDefinition(leftIcon) ? React.createElement(Icon, {
    iconSet: leftIcon.iconSet,
    icon: leftIcon.icon,
    className: "left-icon",
    cypressTag: "icon-left"
  }) : leftIcon), children, rightIcon && (IconUtils.isIconDefinition(rightIcon) ? React.createElement(Icon, {
    iconSet: rightIcon.iconSet,
    icon: rightIcon.icon,
    className: "right-icon",
    cypressTag: "icon-right"
  }) : rightIcon));
};